import React from 'react';

const ErrorMessage = ({ error, onRetry, className = '' }) => {
  if (!error) return null;

  return (
    <div className={`alert alert-danger alert-dismissible fade show ${className}`} role="alert">
      <div className="d-flex align-items-center">
        <i className="fas fa-exclamation-circle text-danger mr-3" style={{ fontSize: '1.5rem' }}></i>
        <div className="flex-grow-1">
          <h5 className="alert-heading mb-1">Error</h5>
          <p className="mb-0">{error}</p>
        </div>
      </div>
      
      {onRetry && (
        <div className="mt-3">
          <button
            type="button"
            onClick={onRetry}
            className="btn btn-outline-danger btn-sm"
          >
            Try again
          </button>
        </div>
      )}
    </div>
  );
};

export default ErrorMessage; 